<template>
  <div>
    <div class="small-3 sku-modal-status--ibd--stock-label">
      <div class="status-box" qaid="rpa-retailer-stock-status">
        <icon v-if="isInStock" name="check_circle" size="default" />
        <span :class="retailerStockClass" v-html="retailerStockMessage" />
      </div>
    </div>
    <div class="small-9 sku-modal-status--ibd--info" qaid="rpa-retailer-info">
      <span class="shop-name" qaid="rpa-retailer-name">
        <trek-link
          v-if="hasRetailerElpUrl"
          :href="retailer.elpURL"
          underline="underline"
          target="_blank"
          :title="bp('retailer')"
          v-html="retailer.name"
        />
        <span v-else v-html="retailer.name" />
      </span>
      <span v-if="retailer.formattedAddress && isModal" class="shop-address" v-html="retailer.formattedAddress" />
      <span
        v-if="retailer.distance"
        class="shop-distance"
        qaid="rpa-retailer-shop-distance"
        v-html="deliveryMessageText"
      />
      <span
        v-if="hasDeliveryMessage"
        class="rpa-msg-delivery"
        v-html="bp(isBike ? 'stockInStoreDelivery' : 'inStoreDeliveryAftermarket')"
      />
      <span v-if="retailer.phoneNumber" class="rpa-msg-inquire">
        <trek-link :href="`tel:${retailer.phoneNumber}`" underline="underline" v-html="retailerPhoneNumber" />
      </span>
    </div>
  </div>
</template>

<script>
import {
  isInStockByCode,
  getRetailerStockMessage,
  isInWarehouseByCode,
} from '@/components/containers/pdp/utils/retailer-helpers';
import {stockStatusConfig} from '@/constants/stock-status';
import {mapGetters} from 'vuex';
import trekLink from '@/components/TrekLink';
import Icon from '@/components/Icon';

export default {
  name: 'PdpRpaSkuStockStatus',
  components: {trekLink, Icon},
  props: {
    isBike: {
      type: Boolean,
      required: true,
    },
    retailer: {
      type: Object,
      default: () => ({}),
      required: false,
    },
    isModal: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters('backend', ['b2b']),
    hasRetailerElpUrl() {
      return this.retailer.elpURL && this.retailer.elpURL.length > 0 && !this.b2b;
    },
    hasDeliveryMessage() {
      return this.retailer.ecommEnabled && this.isInWarehouse;
    },
    deliveryMessageText() {
      return `${this.bp('distance')}: ${this.retailer.distance} ${this.retailer.distanceUnit}`;
    },
    retailerPhoneNumber() {
      return `${this.bp('stockInStoreInquire')} ${this.retailer.phoneNumber}`;
    },
    isInStock() {
      return isInStockByCode(this.retailer.retailerStockStatus);
    },
    retailerStockClass() {
      return stockStatusConfig[this.retailer.retailerStockStatus]?.retailerStockClass;
    },
    isInWarehouse() {
      return isInWarehouseByCode(this.retailer.retailerStockStatus);
    },
    retailerStockMessage() {
      return this.bp(getRetailerStockMessage(this.isBike, this.retailer.retailerStockStatus));
    },
  },
};
</script>
